/** API route map: URLS.Controller.ClientPayrollPayDay */
export const ClientPayrollPayDay = {
      name: 'ClientPayrollPayDay/',
      patch: 'patch',
      read: 'read',
};
